import { IStoreJoinRequestQuery } from "../../models/store-join-request/query";
import { IStoreJoinRequest } from "../../models/store-join-request/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { HttpClient, RequestParams } from "../../utils/api/http-client";

class StoreJoinRequestService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllStoresJoinRequests = (query: IStoreJoinRequestQuery, params?: RequestParams) =>
this.http.request<IBaseListingResponse<IStoreJoinRequest>>({
  path: `/store-join-request`,
  method: "GET",
  query,
  ...params,
});
deleteStoreJoinRequest = (id: number, params?: RequestParams) =>
this.http.request<IStoreJoinRequest>({
  path: `/store-join-request/${id}`,
  method: "DELETE",
  ...params,
});
}

export default StoreJoinRequestService;
